import React, { useState } from "react";
import { useMutation } from "react-query";
import fetcher from "../../../../../dataProvider";

const MessageReaction = ({ reaction, msgId }) => {
  const [reactionemoji, setReactionemoji] = useState(reaction);
  const { mutate: addMessageReaction } = useMutation(({ id, data }) =>
    fetcher.post(`/v1/message/${id}/reaction`, data)
  );

  const handleReactionClick = (emojiId, emojiCount, index) => {
    addMessageReaction(
      { id: msgId, data: { emoji: emojiId } },
      {
        onSuccess: (res) => {
          setReactionemoji((prevState) => {
            const newState = prevState.map((obj) => {
              // 👇️ if id equals emojiId, update emojiId property
              if (obj?.emoji_id === emojiId) {
                return {
                  ...obj,
                  count: res?.totalCount,
                  hasReacted: res?.hasReacted ? true : false,
                };
              }
              // 👇️ otherwise return object as is
              return obj;
            });

            return newState;
          });
        },
        onError: (error) => {
          console.log("Print error:", error);
        },
      }
    );
  };

  return (
    <>
      <div className="message_reaction">
        {reactionemoji?.map((emoji, index) => {
          return (
            <>
              {emoji?.count > 0 ? (
                <>
                  <button
                    type="button"
                    key={emoji?.emoji_id}
                    className={emoji?.hasReacted == true ? "active" : ""}
                    onClick={() => {
                      handleReactionClick(emoji?.emoji_id, emoji?.count, index);
                    }}
                  >
                    {!emoji?.emoji_id?.includes("U") &&
                      String?.fromCodePoint(parseInt(emoji?.emoji_id, 16))}
                    <span style={{ fontSize: "14px", paddingLeft: "5px" }}>
                      {emoji?.count}
                    </span>
                  </button>
                </>
              ) : (
                <> </>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};

export default MessageReaction;
